import { LucideIcon } from 'lucide-react';

interface TabButtonProps {
  isActive: boolean;
  onClick: () => void;
  icon: LucideIcon;
  label: string;
}

export default function TabButton({ isActive, onClick, icon: Icon, label }: TabButtonProps) {
  return (
    <button
      onClick={onClick}
      role="tab"
      aria-selected={isActive}
      className={`
        group relative flex items-center gap-3 px-6 py-4
        font-semibold text-base transition-all duration-200
        border-b-3 outline-none
        ${
          isActive
            ? 'border-blue-600 text-blue-600 bg-blue-50/50'
            : 'border-transparent text-neutral-700 hover:text-blue-600 hover:border-blue-300'
        }
        focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2
      `}
    >
      <Icon
        className={`
          w-6 h-6 transition-transform duration-200
          ${isActive ? 'scale-105' : 'group-hover:scale-110'}
        `}
        strokeWidth={2.5}
      />
      <span className="hidden sm:inline">{label}</span>

      {/* Active indicator */}
      {isActive && (
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-16 h-1 bg-blue-600" />
      )}
    </button>
  );
}
